// Route: /courses/templates — LEGACY redirect → /catalog.
//
// Ведём СРАЗУ на публичный `/catalog`, а не на `/courses/catalog`: последний
// сам стал редиректом, и цепочка из двух переходов дала бы лишний кадр и лишнюю
// запись в истории.
//
// Каталог курсов авторов и «Шаблоны программ» слиты в ЕДИНЫЙ каталог
// (`routes/catalog.tsx`): для пользователя это был один сценарий «дай
// готовую программу», а разница между копией готового курса и генерацией по
// каркасу относится к способу производства и живёт теперь на карточке.
//
// Роут сохранён редиректом: на него ведут ссылки из писем, уведомлений и
// закладок. Контракт search переносится с переименованием `tab` → `scope`
// (вкладка стала личным скоупом каталога), остальные легаси-параметры
// (`category`, `locale`, `q`) не тащим: старая `category` смешивала предмет и
// формат, и подставлять её в новую ось `area` значило бы соврать фильтром.

import { tolerantSearch } from "@studyhub/shared/utils/tolerant-search";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
	tab: z.enum(["catalog", "mine"]).optional(),
	category: z.string().optional(),
	locale: z.string().optional(),
	q: z.string().optional(),
});

export const Route = createFileRoute("/courses/templates")({
	validateSearch: tolerantSearch(searchSchema),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/catalog",
			search: {
				...(search.tab === "mine" ? { scope: "mine" as const } : {}),
				...(search.locale ? { locale: search.locale } : {}),
				...(search.q ? { q: search.q } : {}),
			},
			replace: true,
		});
	},
});
